import _ from 'lodash';
import moment from 'moment';
import React from 'react';
import { connect } from 'react-redux';
import { I18n } from 'react-redux-i18n';
import { Link, withRouter } from 'react-router-dom';
import {
  DropdownMenu,
  DropdownToggle,
  Modal,
  ModalBody,
  ModalHeader,
  UncontrolledButtonDropdown,
} from 'reactstrap';

import { getListProductionOrders } from '../../../../app/store/actions/productionOrders';
import { getProductionOrderTimeTracking } from '../../../../app/store/actions/userTimeTracking';
import addNotification from '../../../../components/notification';
import Table from '../../../../components/table/Table';
import ROUTES from '../../../../config/routes';
import productionOrderHelpers from '../../../../helpers/productionOrder';
import UserTimeTrackingHelpers from '../../../../helpers/userTimeTracking';
import FormatHelpers from '../../../../helpers/format';

class ProductionOrder extends React.PureComponent {
  constructor(props) {
    super(props);

    this.page = 0;
    this.pageSize = 10;
    this.sorted = [];
    this.filtered = [];

    this.state = {
      productionOrderCodeSelected: '',
      defaultPageSize: 10,
      totalDataLength: 0,
      pages: 0,
      listProductionOrderReserves: [],
      listTimeTracking: [],
      startDate: moment().subtract(30, 'd'),
      endDate: moment(),
      openModalReserve: false,
      openModalTimeTracking: false,
      listProductionOrders: [],
    };

    this.defaultSorted = [{
      id: 'createdAt',
      desc: true,
    }];

    this.breadcrumb = [
      {
        value: (
          <>
            <i className="fas fa-home fa-fw m-t-10 m-r-5" />
            {I18n.t('BEE12' /* Início */)}
          </>
        ),
      },
      { value: I18n.t('BEE1400' /* Movimentação */) },
      { value: I18n.t('BEE2771' /* Indústria */) },
      { value: I18n.t('BEE2770' /* Ordem de Produção */), active: true },
    ];

    this.tableColumns = [
      {
        Header: I18n.t('BEE55' /* Ações */),
        accessor: 'action',
        style: { overflow: 'visible', alignSelf: 'center' },
        filterable: false,
        sortable: false,
        width: 100,
        Cell: (rows) => (
          <div style={{ textAlign: 'center' }}>
            <button type="button" className="btn btn-default btn-xs">{I18n.t('BEE55' /* Ações */)}</button>
            {
              <UncontrolledButtonDropdown>
                <DropdownToggle color="default" caret className="btn-xs" />
                <DropdownMenu>
                  {([1, 2, 3].includes(rows.original.status) && (
                    this.props.userLogged ? this.props.userLogged.mainBranchData.serialControlDeposit : false)
                  )
                    && (
                      <Link
                        to={{
                          pathname: ROUTES.INDUSTRY_GENERATE_LABEL_SERIAL,
                          state: {
                            productionOrderCode: rows.original.code,
                          },
                        }}
                        className="dropdown-item"
                      >
                        {I18n.t('BEE2777' /* Gerar etiquetas */)}
                      </Link>
                    )}
                  {
                    rows.original.productionOrderReserve.length > 0
                    && (
                      <button
                        type="button"
                        onClick={() => this.showModalReserve(rows.original)}
                        className="dropdown-item"
                      >
                        {I18n.t('BEE2889' /* Reserva da Ordem */)}
                      </button>
                    )
                  }
                  {
                    this.props.userLogged.mainBranchData.serialControlDeposit && (
                      <Link
                        to={{
                          pathname: ROUTES.INDUSTRY_PRINT_SERIAL_GROUP,
                          state: {
                            productionOrderCode: rows.original.code,
                          },
                        }}
                        className="dropdown-item"
                      >
                        {I18n.t('BEE3254' /* Imprimir Etiquetas Agrupadoras */)}
                      </Link>
                    )
                  }
                  {
                    rows.original
                    && (
                      <button
                        type="button"
                        onClick={() => this.showModalTimeTracking(rows.original)}
                        className="dropdown-item"
                      >
                        {I18n.t('BEE4274' /* Apontamentos */)}
                      </button>
                    )
                  }
                </DropdownMenu>
              </UncontrolledButtonDropdown>
            }
          </div>
        ),
      },
      {
        Header: I18n.t('BEE145' /* Filial */),
        accessor: 'branchCode',
        style: { alignSelf: 'center', textAlign: 'center' },
        minWidth: 100,
        Filter: this.filterColumn,
      }, {
        Header: I18n.t('BEE182' /* Depósito */),
        accessor: 'depositCode',
        style: { alignSelf: 'center', textAlign: 'center' },
        minWidth: 100,
        Filter: this.filterColumn,
      }, {
        Header: I18n.t('BEE2770' /* Ordem de Produção */),
        accessor: 'code',
        style: { alignSelf: 'center', textAlign: 'center' },
        minWidth: 160,
        Filter: this.filterColumn,
      }, {
        Header: I18n.t('BEE378' /* Código do Produto */),
        accessor: 'productCode',
        style: { alignSelf: 'center', textAlign: 'center' },
        minWidth: 150,
        Filter: this.filterColumn,
      }, {
        Header: I18n.t('BEE1043' /* Nome do Produto */),
        accessor: 'product.name',
        style: { alignSelf: 'center', textAlign: 'center' },
        minWidth: 200,
        Filter: this.filterColumn,
      }, {
        Header: I18n.t('BEE1688' /* Quantidade */),
        accessor: 'quantity',
        style: { alignSelf: 'center', textAlign: 'center' },
        minWidth: 110,
        Filter: this.filterColumn,
        Cell: (row) => FormatHelpers.formatNumber(row.value || 0, 4),
      }, {
        Header: I18n.t('BEE384' /* Unidade */),
        accessor: 'product.unitMeasure',
        style: { alignSelf: 'center', textAlign: 'center' },
        minWidth: 100,
        Filter: this.filterColumn,
      }, {
        Header: I18n.t('BEE224' /* Status */),
        accessor: 'status',
        style: { alignSelf: 'center', textAlign: 'center' },
        minWidth: 120,
        Cell: (row) => (
          <div style={{ textAlign: 'center' }}>
            <span>{productionOrderHelpers.productionOrderStatus(row.value)}</span>
          </div>
        ),
        filterMethod: (filter, row) => {
          if (filter.value === row.status.toString()) {
            return true;
          }
        },
        Filter: ({ onChange }) => (
          <select
            type="text"
            style={{ width: '100%', textAlign: 'center' }}
            onChange={(event) => { onChange(event.target.value); }}
          >
            <option value="" key="all">{I18n.t('BEE793' /* Todos */)}</option>
            {productionOrderHelpers.productionOrderStatus().map((elem, index) => (
              <option value={elem.value} key={index}>{elem.label}</option>
            ))}
          </select>
        ),
      }, {
        Header: I18n.t('BEE428' /* Lote */),
        accessor: 'lotNumber',
        style: { alignSelf: 'center', textAlign: 'center' },
        minWidth: 100,
        Filter: this.filterColumn,
      }, {
        Header: I18n.t('BEE434' /* Data de Validade */),
        accessor: 'expirationDate',
        style: { alignSelf: 'center', textAlign: 'center' },
        minWidth: 150,
        filterMethod: (filter, row) => {
          const input = _.lowerCase(filter.value);
          const dateFirstOption = moment(row[filter.id]).format('DD MM YYYY');
          const dateSecondOption = moment(row[filter.id]).format('DDMMYYYY');
          if (_.includes(dateFirstOption, input) || _.includes(dateSecondOption, input)) {
            return true;
          }
        },
        Cell: (row) => (
          <span>
            {' '}
            {row.value ? moment(row.value).format('L') : ''}
          </span>
        ),
      }, {
        Header: I18n.t('BEE502' /* Referência */),
        accessor: 'reference',
        style: { alignSelf: 'center', textAlign: 'center' },
        minWidth: 100,
        Filter: this.filterColumn,
      }, {
        Header: I18n.t('BEE4298' /* Total Apontamentos */),
        accessor: 'totalTimeTracking',
        style: { alignSelf: 'center', textAlign: 'center' },
        minWidth: 160,
        Filter: this.filterColumn,
      }, {
        Header: I18n.t('BEE578' /* Data Criação */),
        accessor: 'createdAt',
        style: { alignSelf: 'center', textAlign: 'center' },
        minWidth: 150,
        filterMethod: (filter, row) => {
          const input = _.lowerCase(filter.value);
          const dateFirstOption = moment(row[filter.id]).format('DD MM YYYY');
          const dateSecondOption = moment(row[filter.id]).format('DDMMYYYY');
          if (_.includes(dateFirstOption, input) || _.includes(dateSecondOption, input)) {
            return true;
          }
        },
        Cell: (row) => (
          <div>
            <span>
              {row.value ? moment(row.value).format('L LTS') : ''}
            </span>
          </div>
        ),
      }];

    this.tableProductColumns = [
      {
        Header: I18n.t('BEE463' /* Linha */),
        accessor: 'lineNumber',
        style: { alignSelf: 'center', textAlign: 'center' },
        minWidth: 100,
      },
      {
        Header: I18n.t('BEE378' /* Código do Produto */),
        accessor: 'productCode',
        style: { alignSelf: 'center', textAlign: 'center' },
        minWidth: 150,
      }, {
        Header: I18n.t('BEE1043' /* Nome do Produto */),
        accessor: 'product.name',
        style: { alignSelf: 'center', textAlign: 'center' },
        minWidth: 200,
      }, {
        Header: I18n.t('BEE1688' /* Quantidade */),
        accessor: 'quantity',
        style: { alignSelf: 'center', textAlign: 'center' },
        minWidth: 110,
        Cell: (row) => FormatHelpers.formatNumber(row.value || 0, 4),
      }, {
        Header: I18n.t('BEE384' /* Unidade */),
        accessor: 'product.unitMeasure',
        style: { alignSelf: 'center', textAlign: 'center' },
        minWidth: 100,
        Filter: this.filterColumn,
      }, {
        Header: I18n.t('BEE2218' /* Quantidade Reservada */),
        accessor: 'reserved',
        style: { alignSelf: 'center', textAlign: 'center' },
        minWidth: 110,
        Cell: (row) => FormatHelpers.formatNumber(row.value || 0, 4),
      }, {
        Header: I18n.t('BEE428' /* Lote */),
        accessor: 'lotNumber',
        style: { alignSelf: 'center', textAlign: 'center' },
        minWidth: 100,
      }];

    this.tableTrackingColumns = [
      {
        Header: I18n.t('BEE4285' /* Data/Hora Início */),
        accessor: 'startedAt',
        style: { alignSelf: 'center', textAlign: 'center' },
        minWidth: 180,
        filterMethod: (filter, row) => {
          const input = _.lowerCase(filter.value);
          const dateFirstOption = moment(row[filter.id]).format('DD MM YYYY');
          const dateSecondOption = moment(row[filter.id]).format('DDMMYYYY');
          if (_.includes(dateFirstOption, input) || _.includes(dateSecondOption, input)) {
            return true;
          }
        },
        Cell: (row) => (
          <span>
            {' '}
            {row.value ? moment(row.value).format('L LTS') : ''}
          </span>
        ),
        Filter: this.filterColumn,
      }, {
        Header: I18n.t('BEE4276' /* Usuário Tarefa */),
        accessor: 'user.login',
        style: { alignSelf: 'center', textAlign: 'center' },
        minWidth: 125,
      }, {
        Header: I18n.t('BEE4278' /* Data/Hora Final */),
        accessor: 'finishedAt',
        style: { alignSelf: 'center', textAlign: 'center' },
        minWidth: 180,
        filterMethod: (filter, row) => {
          const input = _.lowerCase(filter.value);
          const dateFirstOption = moment(row[filter.id]).format('DD MM YYYY');
          const dateSecondOption = moment(row[filter.id]).format('DDMMYYYY');
          if (_.includes(dateFirstOption, input) || _.includes(dateSecondOption, input)) {
            return true;
          }
        },
        Cell: (row) => (
          <span>
            {' '}
            {row.value ? moment(row.value).format('L LTS') : ''}
          </span>
        ),
        Filter: this.filterColumn,
      }, {
        Header: I18n.t('BEE504' /* Total */),
        accessor: 'totalTime',
        style: { alignSelf: 'center', textAlign: 'center' },
        minWidth: 100,
      }, {
        Header: I18n.t('BEE224' /* Status */),
        accessor: 'status',
        style: { alignSelf: 'center', textAlign: 'center' },
        minWidth: 130,
        Cell: (row) => (
          <span>
            {row.value ? UserTimeTrackingHelpers.statusTracking(row.value) : ''}
          </span>
        ),
        Filter: ({ onChange }) => (
          <select
            type="text"
            style={{ width: '100%' }}
            onChange={(event) => { onChange(event.target.value); }}
          >
            <option value="">{I18n.t('BEE793' /* Todos */)}</option>
            {UserTimeTrackingHelpers.statusTracking().map((element, index) => (
              <option key={index} value={element.value}>
                {element.label}
              </option>
            ))}
          </select>
        ),
      }, {
        Header: I18n.t('BEE4275' /* Motivo Finalização */),
        accessor: 'reason.name',
        style: { alignSelf: 'center', textAlign: 'center' },
        minWidth: 300,
      }];
  }

  filterColumn = ({ onChange }) => (
    <input
      type="text"
      style={{ width: '100%' }}
      onKeyPress={(event) => {
        if (event.keyCode === 13 || event.which === 13) {
          onChange(event.target.value);
        }
      }}
      onKeyUp={(event) => {
        if (event.target.value === '' && (event.keyCode === 8 || event.which === 8)) {
          onChange(event.target.value);
        }
      }}
    />
  );

  showModalReserve = async (row) => {
    const orderReserveList = row.productionOrderReserve.sort((a, b) => a.lineNumber - b.lineNumber);
    this.setState({
      openModalReserve: true,
      listProductionOrderReserves: orderReserveList,
      productionOrderCodeSelected: row.code,
    });
  };

  showModalTimeTracking = async (row) => {
    try {
      const listTimeTracking = await this.props.getProductionOrderTimeTracking(row.id);
      this.setState({
        openModalTimeTracking: true,
        listTimeTracking,
        productionOrderCodeSelected: row.code,
      });
    } catch (error) {
      addNotification(
        'danger',
        I18n.t('BEE4274' /* Apontamentos */),
        I18n.t('BEE1969' /* Erro ao buscar dados */),
        'top-right',
      );
    }
  };

  getListProductionOrders = async () => {
    const { startDate, endDate } = this.state;
    try {
      const listProductionOrders = await this.props.getListProductionOrders(
        moment(startDate).format(),
        moment(endDate).format(),
        this.page,
        this.pageSize,
        this.sorted,
        this.filtered,
      );

      this.setState({
        pages: listProductionOrders.pages,
        totalDataLength: listProductionOrders.totalDataLength,
        listProductionOrders: listProductionOrders ? listProductionOrders.rows : [],
      });
    } catch (err) {
      const error = err.response && err.response.data && err.response.data.error;
      if (error && error.message) {
        const messageError = (error.details)
          ? `${error.code} - ${error.details} | ${error.message}`
          : error.message;
        addNotification('danger', I18n.t('BEE2770' /* Ordem de Produção */), messageError, 'top-right');
      } else {
        addNotification(
          'danger',
          I18n.t('BEE2770' /* Ordem de Produção */),
          I18n.t('BEE1969' /* Erro ao buscar dados */),
          'top-right',
        );
      }
    }
  };

  closeModalReserve = () => {
    this.setState({
      openModalReserve: false,
    });
  };

  closeModalTimeTracking = () => {
    this.setState({
      openModalTimeTracking: false,
    });
  };

  handleDateApplyEvent = async (event) => {
    await this.setState({
      startDate: event[0],
      endDate: event[1],
    });
    this.getListProductionOrders();
  };

  render() {
    const {
      defaultPageSize,
      listProductionOrderReserves,
      listTimeTracking,
      openModalReserve,
      openModalTimeTracking,
      productionOrderCodeSelected,
      pages,
      totalDataLength,
      listProductionOrders = [],
    } = this.state;

    return (
      <>
        <Table
          expander
          filterable
          downloadCSV
          wikiHelp={ROUTES.INDUSTRY_PRODUCTION_ORDER_HELP}
          downButtonPosition
          data={listProductionOrders}
          totalDataLength={totalDataLength}
          columns={this.tableColumns}
          pages={pages}
          defaultSorted={this.defaultSorted}
          defaultPageSize={this.pageSize}
          breadcrumb={this.breadcrumb}
          headerTitle={I18n.t('BEE2770' /* Ordem de Produção */)}
          defaultFilterMethod={(filter, row) => {
            const input = _.lowerCase(filter.value);
            const value = _.lowerCase(row[filter.id]);
            if (_.includes(value, input)) {
              return true;
            }
          }}
          manual
          datePicker={{
            handleDateApplyEvent: this.handleDateApplyEvent,
          }}
          panelHeaderProps={{
            onClickReload: this.getListProductionOrders,
          }}
          onFetchData={(state) => {
            this.page = state.page;
            this.pageSize = state.pageSize;
            this.sorted = state.sorted;
            this.filtered = state.filtered;
            this.getListProductionOrders();
          }}
        />

        <Modal size="xl" isOpen={openModalReserve} toggle={this.closeModalReserve} className="adjustmentPadding">
          <ModalHeader toggle={this.closeModalReserve}>
            {`${I18n.t('BEE2889' /* Reserva da Ordem */).toUpperCase()} - ${productionOrderCodeSelected}`}
          </ModalHeader>
          <ModalBody>
            <Table
              expander
              filterable
              downloadCSV
              downButtonPosition
              data={listProductionOrderReserves}
              columns={this.tableProductColumns}
              defaultPageSize={defaultPageSize}
              defaultFilterMethod={(filter, row) => {
                const input = _.lowerCase(filter.value);
                const value = _.lowerCase(row[filter.id]);
                if (_.includes(value, input)) {
                  return true;
                }
              }}
            />
          </ModalBody>
        </Modal>
        <Modal
          size="xl"
          isOpen={openModalTimeTracking}
          toggle={this.closeModalTimeTracking}
          className="adjustmentPadding"
        >
          <ModalHeader toggle={this.closeModalTimeTracking}>
            {`${I18n.t('BEE4274' /* Apontamentos */).toUpperCase()} - ${productionOrderCodeSelected}`}
          </ModalHeader>
          <ModalBody>
            <Table
              filterable
              downloadCSV
              downButtonPosition
              data={listTimeTracking}
              defaultSorted={[{
                id: 'startedAt',
                desc: false,
              }]}
              columns={this.tableTrackingColumns}
              defaultPageSize={defaultPageSize}
              defaultFilterMethod={(filter, row) => {
                const input = _.lowerCase(filter.value);
                const value = _.lowerCase(row[filter.id]);
                if (_.includes(value, input)) {
                  return true;
                }
              }}
            />
          </ModalBody>
        </Modal>
      </>
    );
  }
}

const mapStateToProps = (state) => ({
  userLogged: state.app.userLogged,
  listProductionOrders: state.productionOrders && state.productionOrders.listProductionOrders,
});

const mapDispatchToProps = (dispatch) => ({
  getListProductionOrders: (filterStartDate, filterEndDate, page, pageSize, sorted, filtered) => dispatch(
    getListProductionOrders(filterStartDate, filterEndDate, page, pageSize, sorted, filtered),
  ),
  getProductionOrderTimeTracking: (productionOrderId) => dispatch(getProductionOrderTimeTracking(productionOrderId)),
});

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(ProductionOrder));
